import AbstractTrackingAdapter from './AbstractTrackingAdapter';

export default class LoggerAdapter extends AbstractTrackingAdapter {
  logEvent = (...args) => {
    console.log(...args);
  };

  revenue = (...args) => {
    console.log(...args);
  };

  setUser = (...args) => {
    console.log(...args);
  };
}
